/**
 * VerifyReviewsButton — small admin button that triggers the review-date scanner
 * (POST /api/compliance/calendar/reviews/check). Shows toast with created counts.
 */
import { useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';
import { Button } from './ui/button';
import { CalendarCheck, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function VerifyReviewsButton({ label = 'Verificar revisões', variant = 'outline', size = 'default', className = '', testId = 'verify-reviews-btn' }) {
  const { user } = useAuth();
  const [running, setRunning] = useState(false);
  if (user?.role !== 'admin') return null;

  const run = async () => {
    setRunning(true);
    try {
      const res = await api.post('/compliance/calendar/reviews/check');
      const { tasks_created = 0, alerts_created = 0 } = res.data || {};
      if (tasks_created === 0 && alerts_created === 0) {
        toast.info('Nenhuma revisão nova — todas as datas estão em dia.');
      } else {
        toast.success(`✅ ${tasks_created} tarefa(s) criada(s), ${alerts_created} alerta(s) enviado(s).`);
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Falha ao verificar revisões.');
    } finally {
      setRunning(false);
    }
  };

  return (
    <Button variant={variant} size={size} onClick={run} disabled={running} data-testid={testId} className={className}>
      {running ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <CalendarCheck className="h-3.5 w-3.5 mr-1.5" />}
      {label}
    </Button>
  );
}

export default VerifyReviewsButton;
